import { Fragment } from "react";
import { GROUP_META } from "./definitions";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const Heatmap = ({ cells }) => {
  const max = Math.max(1, ...cells.map((c) => c.total));
  const cell = (d, h) => cells[d * 24 + h];
  return (
    <div className="overflow-x-auto" data-testid="volume-heatmap">
      <div className="grid gap-[3px] min-w-[640px]" style={{ gridTemplateColumns: "36px repeat(24, minmax(0, 1fr))" }}>
        <div />
        {Array.from({ length: 24 }, (_, h) => (
          <div key={h} className="text-[10px] text-slate-400 text-center">{h % 3 === 0 ? h : ""}</div>
        ))}
        {DAYS.map((day, d) => (
          <Fragment key={day}>
            <div className="text-[11px] text-slate-500 flex items-center">{day}</div>
            {Array.from({ length: 24 }, (_, h) => {
              const c = cell(d, h);
              const alpha = c.total ? 0.12 + 0.88 * (c.total / max) : 0;
              return (
                <div key={h} title={`${day} ${h}:00 · ${c.total} conversations · ${c.ai_resolved} AI-resolved${c.out_of_hours ? " · out of hours" : ""}`}
                  className={`relative h-6 rounded-[3px] ${c.out_of_hours ? "ring-1 ring-inset ring-amber-300" : ""}`}
                  style={{ backgroundColor: c.total ? `rgba(66, 91, 118, ${alpha})` : "#f8fafc" }}
                  data-testid={`heatmap-cell-${d}-${h}`}>
                  {c.out_of_hours && c.ai_resolved > 0 && (
                    <span className="absolute top-0.5 right-0.5 w-1.5 h-1.5 rounded-full" style={{ backgroundColor: GROUP_META.ai_resolved.color }} />
                  )}
                </div>
              );
            })}
          </Fragment>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-4 mt-3 text-[11px] text-slate-500">
        <span className="flex items-center gap-1"><span className="w-3 h-3 rounded-sm bg-[#425B76]/80" /> More conversations</span>
        <span className="flex items-center gap-1"><span className="w-3 h-3 rounded-sm ring-1 ring-inset ring-amber-300 bg-white" /> Out of hours</span>
        <span className="flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: GROUP_META.ai_resolved.color }} /> AI resolved out of hours</span>
      </div>
    </div>
  );
};
